module.exports = __webpack_public_path__ + "h5/img/logo.a89d2183.png";